import { configureStore } from './store'
import reducers from './reducers'

const initialState = {}

const store = configureStore(initialState, reducers)

export default store
